import dayjs from 'dayjs'
import React from 'react'

const PateintConfirm = ({ 
  setModalPateintOpen,
  currentRoomPatient,
  selectedPatientInroom,
  handleResignRoom,
  handleUnassignPateint,
  AddedRoom,
  RoomData,
  fetchRoomData,
  fetchSignIndata,
  darkMode
}) => {
  
  const handlePateintCModalClose = () => {
    setModalPateintOpen(false)
  }

  const handleAssignRoom = () => {
    // Call both functions when the button is clicked
    handleUnassignPateint({ Pateints: currentRoomPatient });
    handleResignRoom({
      appointmentid: selectedPatientInroom.appointmentid,
      appointmentdate :dayjs(selectedPatientInroom.startdate).format("YYYY-MM-DD"),
      roomName: AddedRoom.room || RoomData.room,
      roomType: AddedRoom.type || RoomData.type,
      pateintID: selectedPatientInroom.patientid
    });
    handlePateintCModalClose()
  }

  const handleCheckoutRoom = () => {
    handleUnassignPateint({ Pateints: currentRoomPatient });
    handlePateintCModalClose()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col gap-4 w-[30%] bg-white  rounded-[10px] shadow-lg text-left">
        <div className={`px-3 py-1  ${darkMode?'bg-[#333333] text-white':'bg-[#E0E7FF]'} flex items-center justify-between`} style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
          <div className='font-inter text-[18px]'></div>
          <button
            className="text-gray-500 hover:text-gray-700 text-[30px]"
            onClick={handlePateintCModalClose}
          >
            &times;
          </button>
        </div>
<div className='flex justify-center w-full'>
<div className={`px-4 font-inter ${darkMode?"text-[black]":"text-[Red]"} text-[16px] flex `}>
                <div className={` ${darkMode?"text-[black]":"text-[Red]"} font-semibold mr-1`}> {currentRoomPatient.roomno}</div> -  Is currently being used by 
       <br/> {currentRoomPatient.firstname}  {currentRoomPatient.lastname}
                      </div>
</div>
        {/* Modal content */}
        
        <div className='flex w-full flex-col justify-between items-center'>
        <div className='font-inter text-[16px] mb-1'>You Want To Checkout The Room ?</div>

        <div className='flex justify-evenly mt-2 w-full'>
        <div
            className="bg-[#E17954] cursor-pointer rounded-[15px]  text-white px-4 py-2 h-10 "
            onClick={handleCheckoutRoom}
          >
            Checkout 
          </div>
          <div
            className="bg-green-600 px-4 w-[150px] flex cursor-pointer items-center justify-center text-white  py-2 h-10 rounded-[15px] "
            onClick={handleAssignRoom}
          >
            Assign Room
          </div>
        </div>
        {/* Button to assign room */}
        <div className="px-4 py-3 flex justify-center">
      
        </div>
        </div>
     
      </div>
    </div>
  )
}

export default PateintConfirm
